import DefaultProfile from '@src/components/common/defaultProfile';
import { currencyToSymbol } from '@src/utils/pricing';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Avatar, Box, Flex } from 'theme-ui';

type headerProps = {
  vm: any;
  selectedSubject: string;
  selectedDiscount: number;
  priceWithDiscount: number;
  selectedTimes: any;
  lessonCount: number;
  showDateError: boolean;
  isDisabled: boolean;
  setShowSelectedDates: any;
  discountOptions: any;
};
function BookALessonHeader({
  vm,
  selectedSubject,
  selectedDiscount,
  priceWithDiscount,
  selectedTimes,
  lessonCount,
  showDateError,
  isDisabled,
  setShowSelectedDates,
  discountOptions,
}: headerProps) {
  const { t } = useTranslation();
  return (
    <Flex
      pb={3}
      sx={{
        fontSize: ['18px', '20px'],
        gap: ['22px', '28px'],
      }}
    >
      <Box sx={{ position: 'relative', size: ['96px', '96px'] }}>
        {vm.teacherAvatarUrl ? (
          <Avatar
            size="96px"
            sx={{ position: 'absolute', top: 0, left: 0 }}
            src={vm.teacherAvatarUrl}
          />
        ) : (
          <DefaultProfile size={['96px', '96px']} />
        )}
      </Box>

      <Box>
        <Box pb={3} className="lesson-teacher" sx={{ lineHeight: 1.2 }}>
          <div>{vm.teacherName}</div>
          {vm.teacherSubjects && (
            <Box sx={{ color: 'grey600' }}>
              {selectedSubject ? selectedSubject : t('subjectNotSelected')}
            </Box>
          )}
          <Box
            sx={{
              color: 'grey600',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              '@media screen and (max-width: 1330px)': {
                flexDirection: 'column',
                alignItems: 'flex-start',
              },
            }}
          >
            <div>{t('lessonPrice')}: </div>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Box
                sx={{
                  fontWeight: selectedDiscount ? '' : 'bold',
                  color: selectedDiscount ? 'grey600' : 'black',
                  textDecoration: selectedDiscount ? 'line-through' : '',
                }}
              >
                {vm.price} {currencyToSymbol[vm.currency]}
              </Box>

              {selectedDiscount ? (
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    position: 'relative',
                  }}
                >
                  <Box
                    sx={{
                      fontWeight: 'bold',
                      color: 'black',
                    }}
                  >
                    {priceWithDiscount} {currencyToSymbol[vm.currency]}
                  </Box>
                  <Box
                    sx={{
                      borderRadius: '50%',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      fontSize: '16px',
                      fontWeight: 'bold',
                      color: 'black',
                      width: '43px',
                      height: '43px',
                      position: 'absolute',
                      right: '-53px',
                      '@media screen and (max-width: 52em)': {
                        width: '30px',
                        height: '30px',
                        fontSize: '12px',
                        right: '-40px',
                      },
                      background: discountOptions.find(
                        (item) => item.discount === selectedDiscount
                      )?.smallBoxBackground,
                    }}
                  >
                    {'-' + selectedDiscount + '%'}
                  </Box>
                </Box>
              ) : null}
            </Box>
          </Box>
        </Box>

        <Box
          className="lesson-time"
          sx={{
            lineHeight: 1.2,
            width: 'fit-content',
            '@media screen and (max-width: 52em)': {
              marginTop: '10px',
            },
          }}
        >
          {lessonCount > 1 ? (
            <Box
              sx={{
                borderRadius: '5px',
                background: '#D4E1FF',
                fontSize: '16px',
                opacity: !selectedTimes.length ? '0.3' : '1',
                pointerEvents: !selectedTimes.length ? 'none' : 'auto',
                color: lessonCount < selectedTimes.length ? 'red' : 'primary',
                padding: '5px 10px',
                cursor: 'pointer',
                textAlign: 'center',
              }}
              onClick={() => setShowSelectedDates(true)}
            >
              {t('allSelectedTimes')} ({selectedTimes.length})
            </Box>
          ) : (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '5px',
              }}
            >
              <div
                className={
                  isDisabled && showDateError ? 'text-highlight--error' : ''
                }
              >
                {vm.lessonDay}
                {vm.lessonTime && ', '}
              </div>
              <div>{vm.lessonTime}</div>
            </Box>
          )}
        </Box>
      </Box>
    </Flex>
  );
}

export default BookALessonHeader;
